import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService as commonService } from '@common/services/common.service';

@Component({
    selector: 'app-link',
    template: `
        @if (showLink) {
            <a class="cursor-pointer !text-link" [routerLink]="route" [queryParams]="queryParams">
                <ng-container *ngTemplateOutlet="linkContent"></ng-container>
            </a>
        } @else {
            <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        }
        <ng-template #linkContent>
            <ng-content></ng-content>
        </ng-template>
    `
})
export class AppLinkComponent implements OnInit, OnChanges {
    hasPermission: boolean = true;
    showLink: boolean;

    @Input() route: string | string[] | any[];
    @Input() queryParams: Record<string, number | string>;
    @Input() checkPermission: boolean = true;
    @Input() permission: string = '';

    constructor(protected common: commonService) {}

    ngOnInit(): void {
        this.updatePermissionAndLink();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes['route'] || changes['checkPermission'] || changes['permission']) && !changes.route.firstChange) {
            this.updatePermissionAndLink();
        }
    }

    private updatePermissionAndLink(): void {
        this.hasPermission = true;
        if (this.checkPermission) {
            const user = this.common.userService.currentUserSubject.getValue();
            if (!this.permission) this.permission = this.mapRouteToPermission(this.route);
            this.hasPermission =
                user.hasPermission(`${this.permission}`) ||
                user.hasPermission(`${this.permission}.View`) ||
                user.hasPermission(`${this.permission}.View.Own`) ||
                user.hasPermission(`${this.permission}.View.All`);
        }
        // show link if user has permission and last route element is not null
        this.showLink = this.hasPermission && this.route.at(-1) !== null;
    }

    mapRouteToPermission(route: string | string[] | any[]): string {
        let entity: string = typeof route === 'string' ? route.split('/')[1] : '';
        entity = route[0].replace(/^\//, '');
        entity = entity.charAt(0).toUpperCase() + entity.slice(1);
        return entity.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    }
}
